/**
 * WebGLのレイキャスタを作るファイル
 *
 * ユーザがクリックした際の挙動を管理する
 */

import { Raycaster, Vector2, Vector3 } from "three";

import store from "@/store";

const P0 = new Vector3();
const P1 = new Vector3();
const P2 = new Vector2();
const P3 = new Vector2();

const mouse = new Vector2();

export default class RoomRaycaster extends Raycaster {
  constructor() {
    super();

    this.camera = null;
    this.floor = null;

    this.targetObjs = [];
  }
  start(camera, floor) {
    this.camera = camera;
    this.floor = floor;
  }
  addTargetObjs(obj) {
    this.targetObjs.push(obj);
  }
  removeTargetObjs(name, key, index) {
    let cIndex = -1;
    for (let i = 0; i < this.targetObjs.length; i++) {
      const obj = this.targetObjs[i];
      if (obj.name === name && obj.key === key && obj.index === index) {
        cIndex = i;
      }
    }
    if (cIndex != -1) {
      this.targetObjs.splice(cIndex, 1);
    }
  }
  /**
   * floor の Intersect を取得
   */
  getFloorIntersect(mousePos) {
    mouse.set(
      (mousePos.x / store.state.resolution.x) * 2 - 1,
      -(mousePos.y / store.state.resolution.y) * 2 + 1
    );

    this.setFromCamera(mouse, this.camera);
    const intersects = this.intersectObject(this.floor, true);

    if (intersects.length <= 0) return null;

    this.box.position.x = intersects[0].point.x;
    this.box.position.y = intersects[0].point.y;
    this.box.position.z = intersects[0].point.z;

    return intersects[0];
  }

  /**
   * クリックした点から1番近い Intersect を取得
   */
  getIntersect() {
    mouse.set(
      (store.state.touch.vMove.x / store.state.resolution.x) * 2 - 1,
      -(store.state.touch.vMove.y / store.state.resolution.y) * 2 + 1
    );
    this.setFromCamera(mouse, this.camera);
    const intersects = this.intersectObjects(this.targetObjs, false);

    if (intersects.length <= 0) return null;

    // 1つ目のintersectオブジェクトがnodeでvisible = falseの場合
    // 2つ目のintersectオブジェクトを参照する
    if (intersects[0].object.name === "node" && !intersects[0].object.visible) {
      return intersects[1];
    }

    return intersects[0];
  }

  /**
   * intersectの対象になったドアが移動できるかを判定
   *
   * @retutn 0 or 1
   */
  getIsMoveDoor(intersect, door) {
    const face = intersect.face;
    const meshIsRaycaster = door.geometry.attributes.isRaycaster;
    return meshIsRaycaster.getX(face.a);
  }

  /**
   * intersectの対象になったドアの移動先を返す
   *
   * @return Vector2
   */
  getMoveDoorPoint(intersect, door) {
    const face = intersect.face;

    const meshPosition = door.geometry.attributes.position;
    const meshFaceIndex = door.geometry.attributes.faceIndex;

    // ドアの側面（ドアノブのない面）の場合は null を返す
    const tFaceIndex = meshFaceIndex.getX(face.b);
    if (tFaceIndex % 2 == 1) return null;

    const x0 = meshPosition.getX(face.b);
    const z0 = meshPosition.getZ(face.b);
    const x1 = meshPosition.getX(face.a);
    const z1 = meshPosition.getZ(face.a);

    P0.set(x1 - x0, 0, z1 - z0);
    P1.set(0, 1, 0);

    P0.cross(P1);

    // ドアから一定距離話す
    P0.normalize();
    P0.multiplyScalar(0.1);
    P2.set((x0 + x1) * 0.5 + P0.x, (z0 + z1) * 0.5 + P0.z);

    P0.normalize();
    P0.multiplyScalar(0.4);
    P3.set((x0 + x1) * 0.5 - P0.x, (z0 + z1) * 0.5 - P0.z);

    return [P2, P3];
  }
}
